<p>
        After you determine your strategies, it is time to begin making business decisions. In general, you will make decisions about: securities purchases and sales; loan pricing and terms; the types of loans you want your bank to make; deposit pricing and terms;
        retail products pricing and terms; as well as borrowed funding and dividend policy.
        <br><br> Decisions are based on information found in specific BankExec® reports that are numbered from B01 to B99. Community activity reports are numbered in the C90s. Reports are numbered in sequence according to the following scheme:
        <br><br>
        <b> Description of </b>
      </p>
      <table class="table table-striped">
        <tr>
          <th> Reports Available</th>
          <th> Example of Report</th>
          <th></th>
          <th> Reports</th>
        </tr>
        <tr>
          <td> General financial reports</td>
          <td> B01 is the bank's balance sheet </td>
          <td> =></td>
          <td> B00 series </td>
        </tr>
        <tr>
          <td> Investment securities reports</td>
          <td> B12 is the securities portfolio </td>
          <td> =></td>
          <td> B10 series</td>
        </tr>
        <tr>
          <td> Loan reports</td>
          <td> B24 shows loan decisions </td>
          <td> =></td>
          <td> B20 series</td>
        </tr>
        <tr>
          <td> Deposits reports</td>
          <td>B44 shows deposit decisions </td>
          <td> =></td>
          <td> B40 series</td>
        </tr>

        <tr>
          <td> Purchased funds and capital reports </td>
          <td> B64 shows the decisions </td>
          <td> =></td>
          <td> B60 series</td>
        </tr>
        <tr>
          <td> Community activity reports, which are the same for all banks in the community</td>
          <td>C91 shows the balance sheets for all banks in the community </td>
          <td> =></td>
          <td>C90 series</td>
        </tr>
      </table>
      <p>After reviewing your starting position, you are ready to make strategic decisions that will affect the performance of the bank. These decisions will directly affect the next quarter’s results, but will also have long-term implications. For example,
        if you acquire a one year fixed rate loan, this loan will be on your books for one year. If, for example, interest rates go up, you will earn less on this loan than if it had been a variable rate loan (all else equal). Obviously, this type of
        interest rate risk can be avoided by either matching your funding sources or by using variable rate loans. As you know, however, variable rate loans often carry lower interest rates!
        <br><br> The initial decisions are difficult. Your knowledge of banking from a senior management perspective is critical. You are suddenly asked to perform tasks that could be foreign to you. Knowing that the teams you compete against are in
        a similar state of confusion, you must try to anticipate how their decisions will affect your team's plans. This confusion is further compounded by your unfamiliarity with the BankExec® decision structure, financial statements, and operating
        characteristics. It will also be constrained by time limits, making it necessary to organize and use your time efficiently to address the most critical areas.
        <br><br> It is important that you adequately prepare for your participation in BankExec® by studying the simulation manual. You will need to become familiar with the reporting structure and the financial situation of your bank. The knowledge
        you gain will enable you to focus your attention on the management of your bank rather than on the mechanics of the BankExec® platform.
      </p>